module.exports = __webpack_public_path__ + "static/media/studna.1b274ebf.jpg";